import {
  UPDATE_PLACE_OTA_CREDENTIALS,
  UPDATE_PLACE_OTA_CREDENTIALS_FAILED,
  UPDATE_PLACE_OTA_CREDENTIALS_SUCCESS,
} from './actionTypes';

const initialState = {
  isLoadingUpdatePlaceOtaCredentials: false,
};

export default function updatePlaceOtaCredentials(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PLACE_OTA_CREDENTIALS:
      return {
        ...state,
        isLoadingUpdatePlaceOtaCredentials: true,
      };

    case UPDATE_PLACE_OTA_CREDENTIALS_SUCCESS:
    case UPDATE_PLACE_OTA_CREDENTIALS_FAILED:
      return {
        ...state,
        isLoadingUpdatePlaceOtaCredentials: false,
      };

    default:
      return state;
  }
}
